import React from "react";
import LegalShell from "@/components/LegalShell";

export default function PrivacyPolicy() {
  return (
    <LegalShell title="Privacy Policy">
      <div className="space-y-6 text-slate-700 leading-relaxed text-base" data-testid="privacy-content">
        <p>
          We respect your privacy. This Privacy Policy describes how we collect, use, and
          protect your personal information when you visit and interact with this website
          ("BackCare by Dr. Akshay Dhanda").
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>1. Information We Collect</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Personal Information:</strong> Name, phone number, and (optional) email address that you submit through our purchase form.</li>
          <li><strong>Payment Information:</strong> Payments are processed by Razorpay. We do not store your card or UPI details on our servers.</li>
          <li><strong>Usage Data:</strong> Basic anonymous analytics such as pages visited and time spent.</li>
        </ul>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>2. How We Use Your Information</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>To deliver the Back Pain Relief Guide PDF after purchase.</li>
          <li>To contact you on WhatsApp / email for order updates and customer support.</li>
          <li>To improve our content and customer experience.</li>
        </ul>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>3. Sharing of Data</h2>
        <p>
          We do <strong>not</strong> sell, rent, or trade your personal information. We may
          share limited data with trusted service providers (Razorpay for payment processing,
          WhatsApp for content delivery) strictly to fulfill your order.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>4. Data Security</h2>
        <p>
          We take reasonable steps to protect your data. However, no online transmission is
          100% secure. By using this site you accept the inherent risks.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>5. Your Rights</h2>
        <p>
          You may request access, correction, or deletion of your personal data by writing
          to us at <a href="mailto:sudeepm8618@gmail.com" className="text-emerald-600 font-semibold">sudeepm8618@gmail.com</a>.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>6. Cookies</h2>
        <p>
          We may use minimal cookies for site functionality. You can disable cookies in your
          browser settings.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>7. Changes to this Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Continued use of the site
          after changes constitutes acceptance of the updated policy.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>8. Contact</h2>
        <p>
          For privacy concerns, write to <a href="mailto:sudeepm8618@gmail.com" className="text-emerald-600 font-semibold">sudeepm8618@gmail.com</a>.
        </p>
      </div>
    </LegalShell>
  );
}
